export default __webpack_public_path__ + "static/media/pumapay-comment-bg.51c94b48.png";